(function($) {
    if ($('.bottom-banner').length > 0) {

    }
})(jQuery);
